document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 749) return;

  document.querySelectorAll('.footer-block__heading').forEach(function (heading) {
    heading.addEventListener('click', function () {
      const block = heading.closest('.footer-block');
      if (block) block.classList.toggle('active');
    });
  });
});